import { MAX_MULTIPLE_CHOICES } from "@app/constants";
import { Question } from "@app/models/question.model";
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  styled,
} from "@mui/material";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  marginBottom: "16px",
  "& .MuiFormControlLabel-root": {
    marginBottom: "8px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  "& .MuiTypography-root": {
    fontSize: "14px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
  },
}));

interface QuestionCheckboxProps {
  options: string[];
  questions: Question[];
  value: string[];
  onChange: (questions: Question[], value: string[]) => void;
  onFocus: (questionNumber: number) => void;
}

function QuestionCheckbox({ questions, options, value = [], onChange }: QuestionCheckboxProps) {
  const handleChange = (option: string) => {
    const newValue = value.includes(option)
      ? value.filter(v => v !== option)
      : [...value, option];

    onChange(questions, newValue);
  };

  const isTwoOptionsSelected = value.length === MAX_MULTIPLE_CHOICES;

  return (
    <StyledFormControl fullWidth>
      <FormGroup>
        {options.map((option, index) => {
          const isChecked = value.includes(option);

          return (
            <FormControlLabel
              key={`${index}-${questions[0].questionNumber}`}
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={() => handleChange(option)}
                  disabled={isTwoOptionsSelected && !isChecked}
                />
              }
              label={option}
            />
          );
        }
        )}
      </FormGroup>
    </StyledFormControl>
  );
}

export default QuestionCheckbox;
